module.exports = __webpack_public_path__ + "img/policia.4f905c4f.png";